import { request, unwrap } from '../client';
import type {
  ApiResponse,
  InvitationStatus,
  SendInvitationRequest,
  SendInvitationResponse,
  TenantInvitationDto,
} from '../types';

/**
 * Tenant invitations client (saas_auth spec 0011). Mirrors `membersApi`
 * exactly (`request`/`unwrap`, `{ json }` body, `{ query }` for the optional
 * status filter). Endpoints live under `/api/saas-admin/**`, so the bearer +
 * CSRF wiring (spec 0003) applies unchanged.
 */
export const invitationsApi = {
  async list(tenantId: number, status?: InvitationStatus): Promise<TenantInvitationDto[]> {
    const res = await request<ApiResponse<TenantInvitationDto[]>>(
      'GET',
      `/api/saas-admin/tenants/${tenantId}/invitations`,
      status ? { query: { status } } : {},
    );
    return unwrap(res);
  },

  async send(tenantId: number, req: SendInvitationRequest): Promise<SendInvitationResponse> {
    const res = await request<ApiResponse<SendInvitationResponse>>(
      'POST',
      `/api/saas-admin/tenants/${tenantId}/invitations`,
      { json: req },
    );
    return unwrap(res);
  },

  async revoke(tenantId: number, invitationId: number): Promise<void> {
    await request<void>(
      'DELETE',
      `/api/saas-admin/tenants/${tenantId}/invitations/${invitationId}`,
    );
  },
};
